var render, staticRenderFns
import script from "./k-objects.vue?vue&type=script&lang=js&"
export * from "./k-objects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38547bc2')) {
      api.createRecord('38547bc2', component.options)
    } else {
      api.reload('38547bc2', component.options)
    }
    
  }
}
component.options.__file = "src/blocks/k-objects.vue"
export default component.exports